/**
 * コンテンツフィールドの名前からIDを取得します。
 *
 * 表示ラベル（システム設定「コンテンツフィールドの表示ラベル」）が設定されている場合は、
 * 表示ラベルで指定することもできます。管理画面に表示されている名前がそのまま使えるようにするためです。
 * ラベルを先に探すため、表示ラベルが他のフィールドのラベルと同じ文字列でも、これまでと同じIDが返ります。
 *
 * @param {string} label - 検索したいコンテンツフィールドの名前。ラベルまたは表示ラベル
 * @returns {number|undefined} - コンテンツフィールドのID。見つからない場合はundefinedを返す
 */
export function getContentFieldIdByLabel(label) {
    if (
        typeof window.mtappVars === 'undefined' ||
        typeof window.mtappVars.contentType === 'undefined' ||
        typeof window.mtappVars.contentType.fields === 'undefined'
    ) {
        return;
    }

    // 表示ラベルが未設定のフィールドは display_label が空文字になるため、空文字での一致は除く
    const fields = window.mtappVars.contentType.fields;
    const field = fields.find((f) => f.label === label) || fields.find((f) => f.display_label && f.display_label === label);

    if (!field) {
        alert('該当するIDが存在しません。');
        return;
    }

    return field.id;
}
